import { render, staticRenderFns } from "./DocumentExternalMenu.vue?vue&type=template&id=793bc436&scoped=true&"
import script from "./DocumentExternalMenu.vue?vue&type=script&lang=ts&"
export * from "./DocumentExternalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bc436",
  null
  
)

export default component.exports